<template>
  <div>
    <el-drawer
      title="上传视频"
      size="1200px"
      :visible="uploadVideoYoutubeShow"
      append-to-body
      @close="close"
      @opened="openInit"
    >
      <div class="flex flex-col h-[94%]">
        <el-form
          ref="form"
          label-width="100px"
          class="youtubeForm youtubeVideos"
          :model="accountParams"
          :inline="true"
        >
          <YouTubeAccount
            ref="youtubeAccount"
            v-model="accountParams"
            :disabled="accountDisable"
            @change="changeChannel"
          />
          <el-form-item
            label=""
            class="mb-0"
          >
            <el-button
              type="primary"
              @click="openDragUpload"
              >本地上传</el-button
            >
          </el-form-item>
          <el-form-item label="">
            <el-button @click="openLibrary">素材库选择</el-button>
          </el-form-item>
        </el-form>
        <div class="p-2 mt-4 bg-slate-100 rounded-lg">
          <el-form
            ref="form"
            class="youtubeVideos"
            label-width="120px"
            :model="multiTitle"
          >
            <el-form-item
              label="批量设置标题"
              class="w-11/12 inline-block mr-4 mb-0"
              :rules="[{ validator: validateTitle, trigger: 'blur' }]"
            >
              <el-input
                placeholder="输入标题"
                class="w-full"
                v-model="multiTitle.title"
              >
                <template #suffix>
                  <span
                    class="text-[#999999] pr-1"
                    style="font-size: 11px"
                  >
                    {{ multiTitle.title.length }}/100
                  </span>
                </template>
              </el-input>
            </el-form-item>
            <el-button
              type="primary"
              class="inline-block"
              @click="setAllTitle"
              >应用</el-button
            >
          </el-form>
        </div>
        <div class="flex-1 mt-2 overflow-auto">
          <SelectVideoList
            ref="videoList"
            v-model="fileList"
            :title="multiTitle.title"
            @uploadFile="uploadFile"
          />
        </div>
      </div>
      <el-checkbox
        label="允许嵌入（允许他人在其网站中嵌入你的视频）"
        class="mt-[16px]"
        v-model="embeddable"
      ></el-checkbox>
      <div class="absolute right-3 bottom-5">
        <el-button @click="close">取 消</el-button>
        <el-button
          type="primary"
          @click="sure"
          >确 定</el-button
        >
      </div>
    </el-drawer>
    <!-- 个人素材库 -->
    <MaterialLibrary
      :show.sync="materialLibraryShow"
      :saveAdFileParam="saveAdFileParam"
      :adMaterialParams="adMaterialParams"
      uploadTypes="VIDEO"
      @getSelectList="getSelectList"
    />
    <!-- 拖拽上传弹窗 -->
    <DragUploadDialog
      type="video"
      :limit="limit"
      :visible.sync="dragUploadVisible"
      @files-selected="handleDragFiles"
    />
  </div>
</template>
<script>
import YouTubeAccount from '@/views/google/components/YouTubeAccount/index.vue';
import SelectVideoList from '@/views/google/components/SelectVideoList/index.vue';
import getVideoMes from '@adCommonComponent/utils/getVideoMes.js';
import { uploadSingle } from '@/api/common.js';
import GmUploadMaterialMix from '@adCommonComponent/utils/GmUploadMaterialMethods';
import MaterialLibrary from '@/views/google/create/components/creatives/MaterialLibrary/index.vue';
import DragUploadDialog from '@/views/google/create/components/creatives/DragUploadDialog/index.vue';
import { getOptLogId, formatterName } from '../../create/components/creatives/index';
// 校验标题
const validateTitle = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请填写标题'));
  } else {
    if (value.length > 100) {
      callback(new Error('视频标题过长,不能超过100个字符'));
    }
    callback();
  }
};
export default {
  components: { YouTubeAccount, SelectVideoList, MaterialLibrary, DragUploadDialog },
  mixins: [GmUploadMaterialMix],
  props: {
    // 弹窗显示隐藏
    uploadVideoYoutubeShow: {
      type: Boolean,
      default: false,
    },
    // youtube账号
    youtubeChannel: {
      type: Object,
      default: () => {},
    },
    // 账号是否可选
    accountDisable: {
      type: Boolean,
      default: false,
    },
    //素材链路追踪参数
    saveAdFileParam: {
      type: Object,
      default: () => ({}),
    },
    //广告素材库参数
    adMaterialParams: {
      type: Object,
      default: () => ({}),
    },
    // 上传视频数量限制
    limit: {
      type: Number,
      default: 5,
    },
  },

  data() {
    return {
      //youtube账号信息
      accountParams: {
        channelId: null,
      },
      validateTitle,
      multiTitle: { title: '' }, //批量设置标题
      fileList: [], //上传的视频列表
      materialLibraryShow: false,
      dragUploadVisible: false,
      embeddable: true, //是否允许嵌入
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo.data;
    },
  },
  methods: {
    /**
     * 打开弹窗初始化
     */
    openInit() {
      this.$refs.youtubeAccount.getChannel();
      this.$nextTick(() => {
        this.accountParams.channelId = this.youtubeChannel?.id;
      });
      this.fileList = [];
    },
    /**
     * 选择频道
     */
    changeChannel(v) {
      this.accountParams.channelId = v;
    },
    /**
     * 关闭弹窗
     */
    close() {
      this.$emit('update:uploadVideoYoutubeShow', false);
    },
    /**
     * 点击确定
     */
    sure() {
      if (!this.accountParams.channelId) {
        this.$message({
          type: 'warning',
          message: '请选择频道上传视频',
        });
        return;
      }
      this.$refs.videoList.validate().then(() => {
        // 查找当前选中频道的完整对象，获取 youtubeCredentialId
        const selectedChannel = this.$refs.youtubeAccount.options.find((ch) => ch.id === this.accountParams.channelId);
        // 导出，选择的视频文件列表
        this.$emit(
          'updateValue',
          this.fileList.map((v) => {
            console.log(v);
            console.log(formatterName(v.name, v.md5, this.userInfo), 'aaaaaaaaaaaaa', formatterName);
            return {
              youtubeChannelId: this.accountParams.channelId,
              youtubeCredentialId: selectedChannel?.youtubeCredentialId || '',
              videoTitle: v.videoTitle,
              id: v.id,
              ossFileUrl: v.url,
              videoName: v.name,
              fileId: v.fileId,
              accountId: this.saveAdFileParam.adAccountId,
              embeddable: this.embeddable,
            };
          }),
        );
        this.close();
      });
    },
    /**
     * 批量设置标题
     */
    setAllTitle() {
      this.$refs.videoList.setAllTitle(this.multiTitle.title);
    },
    /**
     * 比例误差范围计算
     * @param ratio 目标比例
     * @param errorRatio 误差范围（如 0.01 表示 1%）
     */
    getErrorRatio(ratio, errorRatio) {
      return {
        min: ratio - ratio * errorRatio,
        max: ratio + ratio * errorRatio,
      };
    },
    /**
     * 校验视频大小
     * （横向 16:9、4:3、纵向 9:16、4:5、方形 1:1)
     * 允许 1% 的比例误差
     */
    validateSize(width, height) {
      //视频宽高比
      const ratio = width / height;
      // 各比例允许 1% 误差
      const transverseRatio = this.getErrorRatio(16 / 9, 0.01); //横向 16:9
      const transverse1Ratio = this.getErrorRatio(4 / 3, 0.01); //横向 4:3
      const squareRatio = this.getErrorRatio(1, 0.01); //方形 1:1
      const portraitRatio = this.getErrorRatio(9 / 16, 0.01); //纵向 9:16
      const portrait1Ratio = this.getErrorRatio(4 / 5, 0.01); //纵向 4:5

      const isTransverse = ratio >= transverseRatio.min && ratio <= transverseRatio.max;
      const isTransverse1 = ratio >= transverse1Ratio.min && ratio <= transverse1Ratio.max;
      const isSquare = ratio >= squareRatio.min && ratio <= squareRatio.max;
      const isPortrait = ratio >= portraitRatio.min && ratio <= portraitRatio.max;
      const isPortrait1 = ratio >= portrait1Ratio.min && ratio <= portrait1Ratio.max;
      //  false 代表所有比例都不符合
      return isTransverse || isSquare || isPortrait || isTransverse1 || isPortrait1;
    },
    /**
     * 校验视频格式，大小，比例
     */
    validateVideo(file, video) {
      return new Promise((resolve, reject) => {
        const raw = video ? {} : file.raw;
        const videoType = ['video/mp4'];
        const fileSize = video ? video.file_size / 1024 / 1024 : raw.size / 1024 / 1024;
        // 格式限制
        if (videoType.includes(raw.type) || video) {
          // 大小限制
          //   const isLt5MB = fileSize <= 5;
          //   if (!isLt5MB) {
          //     return reject('文件限制在5MB以内');
          //   }
          getVideoMes(file || video.url)
            .then((res) => {
              const { duration, videoWidth, videoHeight } = res;
              if (!this.validateSize(videoWidth, videoHeight)) {
                return reject('请选择16:9 / 4:3 / 4:5 / 1:1 / 9:16的视频');
              }
              if (duration < 10 && duration > 60) {
                return reject('请上传时长在10s以上60s以内的视频');
              }
              resolve();
            })
            .catch((err) => {
              return reject('文件加载失败');
            });
        } else {
          reject('文件格式不正确');
        }
      });
    },
    /**
     * 选择文件
     */
    selectVideo(file, fileList) {
      this.validateVideo(file)
        .then(() => {
          this.fileList.push({
            ...file,
            raw: file.raw, // 确保保存raw数据
            status: 'uploading',
            videoTitle: '',
            blobUrl: file.url,
          });
          this.uploadFile(file);
        })
        .catch((err) => {
          this.$message.error(err);
          //   let index = this.fileList.findIndex((v) => v.uid == file.uid);
          //   this.fileList.splice(index, 1);
        });
    },
    // 截取视频名称
    spliceFileName(str) {
      let lastIndex = str.lastIndexOf('.');
      return str.substring(0, lastIndex).slice(0, 100); //
    },
    // 上传视频到oss服务器
    async uploadFile(file) {
      let index = this.fileList.findIndex((v) => v.uid === file.uid);
      if (index === -1) return; // 防止找不到文件

      // 检查file.raw是否存在，如果不存在则使用fileList中的raw
      const rawFile = file.raw || this.fileList[index].raw;
      if (!rawFile) {
        console.error('文件raw数据丢失:', file);
        this.$set(this.fileList, index, { ...this.fileList[index], status: 'error' });
        return;
      }

      console.log(this.fileList[index]);
      this.$set(this.fileList, index, {
        ...this.fileList[index],
        status: 'uploading',
        videoTitle: this.spliceFileName(this.fileList[index].name),
      });

      try {
        console.log(rawFile, 'rawFilerawFilerawFile');
        let res = await this.httpRequest(rawFile);
        let currentIndex = this.fileList.findIndex((v) => v.uid === file.uid); //重新获取index
        if (currentIndex === -1) return; // 防止上传过程中文件被删除

        console.log(currentIndex, 11111, res, 33333);
        if (res.status == 'error') {
          this.$set(this.fileList, currentIndex, {
            ...this.fileList[currentIndex],
            status: 'error',
            name: formatterName(res.name, res.md5, this.userInfo),
          });
          return;
        }

        this.$set(this.fileList, currentIndex, {
          ...this.fileList[currentIndex],
          status: 'success',
          url: res.url,
          id: res.id,
          fileId: res.id,
          name: formatterName(res.name, res.md5, this.userInfo),
        });

        // 上传成功后记录操作日志
        try {
          getOptLogId({
            adAccountId: this.currentAccount.id,
            mediaType: 'VIDEO',
            fileId: res.id,
            sourceType: 'UPLOAD',
          });
        } catch {}
      } catch {
        let currentIndex = this.fileList.findIndex((v) => v.uid === file.uid);
        if (currentIndex !== -1) {
          this.$set(this.fileList, currentIndex, { ...this.fileList[currentIndex], status: 'error' });
        }
      }
    },
    //从素材库选择
    openLibrary() {
      this.materialLibraryShow = true;
    },
    /**
     * 打开拖拽上传弹窗
     */
    openDragUpload() {
      this.dragUploadVisible = true;
    },
    /**
     * 处理拖拽文件
     */
    handleDragFiles(files) {
      files.forEach((file) => {
        const fakeFile = {
          uid: Date.now() + Math.random(),
          raw: file,
          name: file.name,
          url: URL.createObjectURL(file),
        };
        this.selectVideo(fakeFile);
      });
    },
    // 获取素材库选择的素材
    getSelectList(list) {
      list.forEach(async (video) => {
        try {
          getOptLogId({
            adAccountId: this.currentAccount.id,
            mediaType: 'VIDEO',
            fileId: video.file_id,
            sourceType: 'SELF_LIB',
          });
        } catch {}
        console.log(video, 'video');
        this.validateVideo(null, video)
          .then((res) => {
            this.fileList = [
              ...this.fileList,
              {
                ...video,
                videoTitle: this.spliceFileName(video.file_name),
                status: 'success',
                blobUrl: video.url,
                fileId: video.file_id,
                name: formatterName(video.file_name, video.md5_code, this.userInfo),
              },
            ];
          })
          .catch((err) => {
            this.$message.close();
            this.$message.error(err);
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-upload--picture-card {
  width: auto !important;
  height: auto !important;
  border: none;
  line-height: 1;
}
::v-deep .el-drawer__body {
  position: relative;
  padding: 20px;
}
::v-deep .el-input--suffix .el-input__inner {
  padding-right: 48px;
}
</style>
<style lang="scss">
// 解决输入框受外部表单验证的影响
.youtubeVideos .el-input__inner {
  border-color: #dcdfe6 !important; /* 取消红色边框 */
  box-shadow: none !important; /* 取消红色阴影 */
}
</style>
